jQuery(document).ready(function ($) {
  "use strict";

  $(".js-navbar").each(function () {
    let self = {
      class: "js-navbar",
      navbarEl: $(this),
      isStuckMobile: null,
      resizeTimer: {
        global: null,
        subContainerHeights: null,
      },
      subScrollbarClass: "overflow-y-auto overflow-x-hidden",
    };

    self.menuBaseEl = self.navbarEl.find(`.${self.class}__menu-base`);
    self.togglerEl = self.navbarEl.find(`.${self.class}__toggler`);
    self.closeEl = self.navbarEl.find(`.${self.class}__close`);
    self.menuContainerEl = self.navbarEl.find(`.${self.class}__menu-container`);
    self.menuEl = self.navbarEl.find(`.${self.class}__menu`);
    self.buttonEl = self.navbarEl.find(`.${self.class}__button`);
    self.menuIconEls = self.navbarEl.find(`.${self.class}__menu-icon`);
    self.headerBarContentEl = self.navbarEl.find(
      `.${self.class}__header-bar-content`
    );
    self.headerContentEl = self.navbarEl.find(`.${self.class}__header-content`);
    self.subShadowEls = self.navbarEl.find(`.${self.class}__sub-shadow`);
    self.menuSubHeightEls = self.navbarEl.find(
      `.${self.class}__menu-sub-height`
    );
    self.menuSubColumnElSet = [];
    self.headerContainerEl = self.navbarEl.find(
      `.${self.class}__header-container`
    );
    self.menuSubTriggerEls = self.navbarEl.find(
      `.${self.class}__menu-sub-trigger`
    );
    self.menuSubContentEls = self.navbarEl.find(
      `.${self.class}__menu-sub-content`
    );
    self.menuSubScrollbarEls = self.navbarEl.find(
      `.${self.class}__menu-sub-scrollbar`
    );
    self.menuSubContentRootEls = self.menuSubContentEls.filter(
      `.${self.class}__menu-sub-content--root`
    );
    self.hasMenuItemEls = self.navbarEl.find(
      `.${self.class}__menu-item.menu-item-has-children`
    );
    self.hasMenuToggleIconEls = self.navbarEl.find(
      `.${self.class}__menu-item.menu-item-has-children > span > .${self.class}__menu-toggle-icon`
    );
    self.hasSubMenuEls = self.navbarEl.find(
      `.${self.class}__menu-item.menu-item-has-children > .${self.class}__sub-menu`
    );
    self.searchEl = self.navbarEl.find(`.${self.class}__search`);
    self.contactstickEl = self.navbarEl.find(`.${self.class}__contact-stick`);
    self.contactfixedEl = self.navbarEl.find(`.${self.class}__contact-fixed`);

    self.observerDesktop = new IntersectionObserver(
      ([e]) => {
        if (window.matchMedia("(min-width: 1024px)").matches) {
          self.toggleStuckStylesDesktop(e.intersectionRatio < 1);
        }
      },
      { threshold: [1] }
    );

    self.checkStickinessMobile = () => {
      let isStuck = $(window).scrollTop() > 52;

      if (isStuck === self.isStuckMobile) {
        return;
      }

      self.isStuckMobile = isStuck;
      self.toggleStuckStylesMobile();
    };

    self.toggleStuckStylesMobile = () => {
      self.headerBarContentEl.toggleClass("h-7", self.isStuckMobile);
      self.headerBarContentEl.toggleClass("h-12", !self.isStuckMobile);
      self.headerContentEl.toggleClass("h-22", self.isStuckMobile);
      self.headerContentEl.toggleClass("h-30", !self.isStuckMobile);
      self.headerContainerEl.toggleClass("bg-white", self.isStuckMobile);
      self.menuSubContentRootEls.toggleClass("mt-29", self.isStuckMobile);
      self.menuSubContentRootEls.toggleClass("mt-42", !self.isStuckMobile);
      self.searchEl.addClass("js-navbar__search--mobile", !self.isStuckMobile);
    };

    self.toggleStuckStylesDesktop = (isStuck) => {
      self.menuBaseEl.toggleClass(
        "lg:bg-white lg:shadow-lg lg:border-opacity-100 js-navbar__menu-base--sticky",
        isStuck
      );
      self.subShadowEls.toggleClass("shadow-inner", isStuck);
      self.menuEl.toggleClass("border-opacity-0", isStuck);
      self.buttonEl.toggleClass("hidden", !isStuck);
      self.menuIconEls.toggleClass("lg:hidden xl:block", isStuck);
      self.searchEl.toggleClass("js-navbar__search--scroll", isStuck);
      self.contactstickEl.toggleClass("hidden", isStuck);
      self.contactfixedEl.toggleClass("hidden", !isStuck);
      self.headerContainerEl.toggleClass("bg-white", !self.isStuckMobile);
    };

    self.searchEl.find(".search-form__trigger").on("click", function (e) {
      console.log($(this).parent());
      $(this).parent().addClass("js-navbar__search--opened");
      $("body").addClass("with-search-opened");
      $(document).on("click", function (event) {
        if (!$(event.target).closest(self.searchEl).length) {
          self.searchEl.removeClass("js-navbar__search--opened");
          $("body").removeClass("with-search-opened");
        }
      });
    });

    self.checkMobile = () => {
      let isMobile = !window.matchMedia("(min-width: 1024px)").matches;

      if (isMobile === self.isMobile) {
        return;
      }

      self.isMobile = isMobile;
      self.onChangeDevice();
    };

    self.toggleHeaderContainer = (state) => {
      self.headerContainerEl.toggleClass("z-40 left-0", !state);
      self.headerContainerEl.toggleClass(
        "z-50 left-full -translate-x-full",
        state
      );
      // The header container's inner backgrounds are semi-transparent
      // (bg-gray-light/70 and bg-white-smoke/80) and only get an opaque
      // bg-white when the page is scroll-stuck. That means when a sub-menu
      // opens at the top of the page, the main-menu items sitting in
      // js-navbar__menu-base bleed through the "empty" mt-42 strip at the
      // top of the sub-content. Force an opaque background while a
      // sub-menu is open, and restore the scroll-stuck state on close.
      self.headerContainerEl.toggleClass(
        "bg-white",
        state || !!self.isStuckMobile
      );
    };

    self.setSubContainerHeights = () => {
      self.menuSubHeightEls.each(function (index) {
        let menuSubHeightEl = $(this);
        let heights = [];

        menuSubHeightEl.css("height", "");
        heights.push(menuSubHeightEl.height());

        self.menuSubColumnElSet[index].each(function (index) {
          heights.push($(this).height());
        });

        menuSubHeightEl.height(Math.max.apply(Math, heights));
      });
    };

    self.onChangeDevice = () => {
      self.menuBaseEl.removeClass("translate-y-full");

      if (self.isMobile) {
        self.observerDesktop.unobserve(self.menuBaseEl.get(0));
        self.menuBaseEl.removeClass("lg:transition-bg-border-shadow");
        self.toggleStuckStylesDesktop(false);
        setTimeout(() => {
          self.headerBarContentEl.addClass("transition-height");
          self.headerContentEl.addClass("transition-height");
        }, 100);
        $(document).on("scroll.navbar", self.checkStickinessMobile);
        self.checkStickinessMobile();
        self.togglerEl.on("click.navbar", (event) => {
          event.preventDefault();

          if (!self.menuBaseEl.hasClass("translate-y-full")) {
            bodyScrollLock.disableBodyScroll(self.menuContainerEl.get(0), {
              reserveScrollBarGap: false,
            });
            self.menuBaseEl.addClass("translate-y-full");
          } else {
            self.headerContainerEl.removeClass("-translate-x-full");
            self.menuSubContentEls.addClass("translate-x-full");
            self.menuContainerEl.addClass("overflow-y-auto");
          }
        });
        self.closeEl.on("click.navbar", (event) => {
          event.preventDefault();
          bodyScrollLock.clearAllBodyScrollLocks();
          self.menuBaseEl.removeClass("translate-y-full");
          self.toggleHeaderContainer(false);
        });
        $(window).off("resize.navbarsubcont");
        clearTimeout(self.resizeTimer.subContainerHeights);
        self.menuSubHeightEls.css("height", "");
        self.menuSubTriggerEls.each(function (index) {
          let menuNavTriggerEl = $(this);
          let menuNavContentEl = menuNavTriggerEl.next(
            `.${self.class}__menu-sub-content`
          );
          let menuNavScrollbarEl = menuNavContentEl.children(
            `.${self.class}__menu-sub-scrollbar`
          );
          let menuNavBackEl = menuNavContentEl.children(
            `.${self.class}__menu-sub-back`
          );
          let menuNavScrollbarParentEl = menuNavTriggerEl
            .closest(`.${self.class}__menu-sub-content`)
            .children(`.${self.class}__menu-sub-scrollbar`);

          menuNavTriggerEl.on("click.navbar", (event) => {
            if (
              !menuNavTriggerEl.hasClass(
                "js-navbar__menu-sub-trigger--submenu-disabled"
              )
            ) {
              event.preventDefault();
              self.toggleHeaderContainer(true);
              menuNavContentEl.removeClass("translate-x-full");
              self.menuContainerEl.removeClass("overflow-y-auto");
              self.menuSubScrollbarEls.removeClass(self.subScrollbarClass);
              menuNavScrollbarEl.addClass(self.subScrollbarClass);
            }
          });

          menuNavBackEl.on("click.navbar", (event) => {
            event.preventDefault();

            menuNavContentEl.addClass("translate-x-full");
            menuNavScrollbarEl.removeClass(self.subScrollbarClass);
            menuNavScrollbarParentEl.addClass(self.subScrollbarClass);
          });
        });
        self.hasMenuItemEls.each(function (index) {
          $(this).on("click.navbar", (event) => {
            if (0 === $(event.target).closest("a").length) {
              event.preventDefault();

              $(self.hasMenuToggleIconEls.get(index)).toggleClass("rotate-180");

              $(self.hasSubMenuEls.get(index)).slideToggle(300, function () {
                $(this).css("display", "").toggleClass("hidden");
              });
            }
          });
        });
        // Close the mobile menu when a real navigation link inside it is
        // tapped. Without this, same-page anchor links (e.g. sub-items under
        // "About us" that jump to sections on /about-us/) only scroll the
        // document behind the open overlay, so the user sees nothing change.
        self.menuContainerEl.find("a").on("click.navbar", (event) => {
          const linkEl = $(event.currentTarget);
          if (linkEl.hasClass(`${self.class}__menu-sub-trigger`)) {
            return;
          }
          if (linkEl.closest(`.${self.class}__menu-sub-back`).length) {
            return;
          }
          bodyScrollLock.clearAllBodyScrollLocks();
          self.menuBaseEl.removeClass("translate-y-full");
          self.toggleHeaderContainer(false);
        });
      } else {
        self.menuSubTriggerEls.off("click.navbar");
        self.menuSubContentEls.addClass("translate-x-full");
        self.menuSubScrollbarEls.removeClass(self.subScrollbarClass);
        self.toggleHeaderContainer(false);
        self.observerDesktop.observe(self.menuBaseEl.get(0));
        self.headerBarContentEl.removeClass("transition-height");
        self.headerContentEl.removeClass("transition-height");
        $(document).off("scroll.navbar");
        self.togglerEl.off("click.navbar");
        self.closeEl.off("click.navbar");
        bodyScrollLock.clearAllBodyScrollLocks();
        setTimeout(() => {
          self.menuBaseEl.addClass("lg:transition-bg-border-shadow");
        }, 100);
        $(window).on("resize.navbarsubcont", () => {
          clearTimeout(self.resizeTimer.subContainerHeights);
          self.resizeTimer.subContainerHeights = setTimeout(() => {
            self.setSubContainerHeights();
          }, 100);
        });
        self.setSubContainerHeights();
        self.hasMenuItemEls.off("click.navbar");
        self.menuContainerEl.find("a").off("click.navbar");
      }
    };

    $(window).on("resize", () => {
      clearTimeout(self.resizeTimer.global);
      self.resizeTimer.global = setTimeout(() => {
        self.checkMobile();
      }, 100);
    });

    self.menuSubHeightEls.each(function (index) {
      self.menuSubColumnElSet[index] = $(this).find(
        `.${self.class}__menu-sub-column`
      );
    });

    self.checkMobile();
  });

  // Hide search after scroll
  $(document).on("scroll", function () {
    $(".js-navbar__search--opened").removeClass("js-navbar__search--opened");
    $(".with-search-opened").removeClass("with-search-opened");
  });

  // Function to show the dropdown
  function showDropdown(dropdown) {
    dropdown
      .removeClass("opacity-0 translate-y-5 -z-10 pointer-events-none") // Remove hidden classes
      .addClass("opacity-100 translate-y-0 z-10 pointer-events-auto"); // Add visibility classes
  }

  // Function to hide the dropdown
  function hideDropdown(dropdown) {
    dropdown
      .removeClass("opacity-100 translate-y-0 z-10 pointer-events-auto") // Remove visibility classes
      .addClass("opacity-0 translate-y-5 -z-10 pointer-events-none"); // Add hidden classes
  }

  // Function to switch the button label to active state
  function setButtonLabelToActive() {
    $(".js-tools-trigger__label--default").addClass("hidden"); // Hide default label on all triggers
    $(".js-tools-trigger__label--active").removeClass("hidden"); // Show active label on all triggers
  }

  // Function to switch the button label to default state
  function setButtonLabelToDefault() {
    $(".js-tools-trigger__label--active").addClass("hidden"); // Hide active label on all triggers
    $(".js-tools-trigger__label--default").removeClass("hidden"); // Show default label on all triggers
  }

  // Add click event handler to open and close the dropdown
  $(".js-tools-trigger").on("click", function (event) {
    event.preventDefault(); // Prevent default behavior of links or buttons
    const dropdown = $(".js-tools-dropdown");

    // Toggle the dropdown visibility
    if (dropdown.hasClass("opacity-100")) {
      hideDropdown(dropdown);
      setButtonLabelToDefault(); // Set label to default when dropdown is hidden
    } else {
      showDropdown(dropdown);
      setButtonLabelToActive(); // Set label to active when dropdown is shown
    }
  });

  // Optionally: hide the dropdown when clicking outside of it
  $(document).on("click", function (event) {
    if (
      !$(event.target).closest(".js-tools-trigger, .js-tools-dropdown").length
    ) {
      hideDropdown($(".js-tools-dropdown"));
      setButtonLabelToDefault(); // Set label to default when clicking outside
    }
  });

  // Hide dropdown when hovering over ".js-navbar__menu-sub-trigger"
  $(".js-navbar__menu-sub-trigger").on("mouseenter", function () {
    hideDropdown($(".js-tools-dropdown"));
    setButtonLabelToDefault(); // Set label to default when hiding dropdown
  });
});
